import React from "react";
import PropTypes from "prop-types";
import humps from "humps";
import { FormattedMessage } from "react-intl";

import SmokingIcon from "assets/images/icon/icon-smoking.svg";
import ActivityIcon from "assets/images/icon/icon-activity.svg";
import ScreeningIcon from "assets/images/icon/icon-screening.svg";
import NutritionIcon from "assets/images/icon/icon-nutrition.svg";
import StressIcon from "assets/images/icon/icon-stress.svg";
import BodyFatIcon from "assets/images/icon/icon-body-fat.svg";
import PainIcon from "assets/images/icon/icon-pain.svg";
import AlcoholIcon from "assets/images/icon/icon-alcohol.svg";
import SleepIcon from "assets/images/icon/icon-sleep.svg";
import MentalHealthIcon from "assets/images/icon/icon-mental-health.svg";

const icons = {
  SmokingIcon: <SmokingIcon />,
  ActivityIcon: <ActivityIcon />,
  ScreeningIcon: <ScreeningIcon />,
  NutritionIcon: <NutritionIcon />,
  StressIcon: <StressIcon />,
  BodyFatIcon: <BodyFatIcon />,
  PainIcon: <PainIcon />,
  AlcoholIcon: <AlcoholIcon />,
  SleepIcon: <SleepIcon />,
  MentalHealthIcon: <MentalHealthIcon />,
};

const HraResultRiskType = ({ item, currentRiskDomain, riskItemClicked }) => {
  const { id, name, riskLevel } = item;

  const selectedClass = currentRiskDomain === id ? "risk-item--selected" : "";

  return (
    <div className={`grid__item risk-item risk-item--${riskLevel} ${selectedClass}`}>
      <figure>
        <button className="risk-item__button" onClick={() => riskItemClicked(id)}>
          {icons[`${humps.pascalize(id)}Icon`]}
        </button>
        <figcaption>
          <FormattedMessage id={name} defaultMessage={name} />
        </figcaption>
      </figure>
    </div>
  );
};

HraResultRiskType.propTypes = {
  item: PropTypes.object,
  currentRiskDomain: PropTypes.string,
  riskItemClicked: PropTypes.func.isRequired,
};

export default HraResultRiskType;



// WEBPACK FOOTER //
// ./components/wellness/lifestyleAgeing/results/hraResultRiskType.jsx